export interface TopicCategory {
  id: string;
  slug: string;
  title: string;
  description: string;
  keywords: string[];
  icon: string;
}

export const LEGAL_TOPICS: TopicCategory[] = [
  {
    id: 't1',
    slug: 'constitutional-law',
    title: 'Constitutional Law',
    description: 'Landmark judgments, articles, and public laws regarding the interpretation and application of the Constitution of Pakistan.',
    keywords: ['constitution', 'fundamental rights', 'article 184', 'article 199', 'writ petition', 'judicial review', 'parliament'],
    icon: 'Landmark'
  },
  {
    id: 't2',
    slug: 'criminal-law',
    title: 'Criminal Law',
    description: 'Precedents and statutes concerning offenses, criminal procedures, bail matters, and the Pakistan Penal Code (PPC).',
    keywords: ['criminal', 'ppc', 'crpc', 'murder', 'bail', 'acquittal', 'f.i.r', 'police', 'investigation', 'narcotics'],
    icon: 'Shield'
  },
  {
    id: 't3',
    slug: 'family-law',
    title: 'Family Law',
    description: 'Cases and legislation covering marriage, divorce (khula), child custody, maintenance, and inheritance rights.',
    keywords: ['family', 'divorce', 'khula', 'custody', 'maintenance', 'inheritance', 'guardian', 'minor', 'dowry'],
    icon: 'Users'
  },
  {
    id: 't4',
    slug: 'corporate-law',
    title: 'Corporate & Commercial Law',
    description: 'Legal resources on companies ordinance, corporate governance, mergers, contracts, and commercial disputes.',
    keywords: ['corporate', 'company', 'secp', 'contract', 'commercial', 'merger', 'shares', 'winding up', 'business'],
    icon: 'Building2'
  },
  {
    id: 't5',
    slug: 'taxation-law',
    title: 'Taxation Law',
    description: 'Tax codes, FBR regulations, income tax ordinances, sales tax, and customs-related jurisprudence.',
    keywords: ['tax', 'income tax', 'fbr', 'sales tax', 'customs', 'revenue', 'tariff', 'taxation', 'excise'],
    icon: 'Calculator'
  },
  {
    id: 't6',
    slug: 'property-law',
    title: 'Property & Land Law',
    description: 'Real estate regulations, land acquisition, property disputes, rent control, and transfer of property.',
    keywords: ['property', 'land', 'real estate', 'rent', 'lease', 'tenant', 'landlord', 'acquisition', 'transfer of property'],
    icon: 'Home'
  },
  {
    id: 't7',
    slug: 'labor-law',
    title: 'Labor & Employment Law',
    description: 'Workplace regulations, employee rights, trade unions, wrongful termination, and industrial relations.',
    keywords: ['labor', 'employment', 'worker', 'trade union', 'dismissal', 'termination', 'industrial', 'pension', 'wages'],
    icon: 'Briefcase'
  },
  {
    id: 't8',
    slug: 'cybercrime-and-technology',
    title: 'Cybercrime & Technology',
    description: 'Laws and precedents regarding digital offenses, PECA, electronic evidence, and data privacy.',
    keywords: ['cyber', 'peca', 'electronic', 'fia', 'data privacy', 'internet', 'social media', 'defamation'],
    icon: 'Laptop'
  },
  {
    id: 't9',
    slug: 'environmental-law',
    title: 'Environmental Law',
    description: 'Regulations and rulings concerning environmental protection, pollution control, and climate change litigation.',
    keywords: ['environment', 'epa', 'pollution', 'climate', 'smog', 'water', 'forest', 'conservation'],
    icon: 'TreePine'
  },
  {
    id: 't10',
    slug: 'intellectual-property',
    title: 'Intellectual Property (IP)',
    description: 'Copyrights, trademarks, patents, and protections of intellectual creations in Pakistan.',
    keywords: ['ipr', 'copyright', 'trademark', 'patent', 'ipo', 'infringement', 'design', 'intellectual property'],
    icon: 'Lightbulb'
  },
  {
    id: 't11',
    slug: 'civil-procedure',
    title: 'Civil Procedure & Litigation',
    description: 'Rules regarding civil lawsuits, CPC, jurisdiction, injunctions, and appellate procedures.',
    keywords: ['civil', 'cpc', 'injunction', 'jurisdiction', 'appeal', 'revision', 'decree', 'suit'],
    icon: 'Scale'
  },
  {
    id: 't12',
    slug: 'islamic-jurisprudence',
    title: 'Islamic Jurisprudence',
    description: 'Decisions by the Federal Shariat Court and applications of Islamic law and injunctions.',
    keywords: ['shariat', 'islamic', 'hadd', 'zakat', 'waqf', 'qisas', 'diyat'],
    icon: 'Book'
  },
  {
    id: 't13',
    slug: 'banking-law',
    title: 'Banking & Finance Law',
    description: 'Regulations of financial institutions, State Bank of Pakistan rules, loan recovery, and banking offenses.',
    keywords: ['bank', 'finance', 'sbp', 'loan', 'recovery', 'mortgage', 'cheque', 'dishonour'],
    icon: 'Landmark'
  },
  {
    id: 't14',
    slug: 'human-rights',
    title: 'Human Rights',
    description: 'Legal cases regarding enforced disappearances, minority rights, freedom of speech, and human dignity.',
    keywords: ['human rights', 'missing persons', 'minority', 'freedom of speech', 'torture', 'dignity'],
    icon: 'Heart'
  },
  {
    id: 't15',
    slug: 'election-law',
    title: 'Election Law',
    description: 'Cases involving the Election Commission of Pakistan (ECP), voter rights, disqualification, and election tribunals.',
    keywords: ['election', 'ecp', 'vote', 'disqualification', 'article 62', 'article 63', 'tribunal', 'ballot'],
    icon: 'Vote'
  }
];

export const getTopicBySlug = (slug: string): TopicCategory | undefined => {
  return LEGAL_TOPICS.find(t => t.slug === slug);
};

export const computeTopicSlugs = (title: string, summary: string, docKeywords: string[] = []): string[] => {
  const text = ((title || '') + ' ' + (summary || '') + ' ' + docKeywords.join(' ')).toLowerCase();
  
  const matchedSlugs: string[] = [];
  
  for (const topic of LEGAL_TOPICS) {
    const topicKeywords = topic.keywords.map(k => k.toLowerCase());
    if (topicKeywords.some(k => text.includes(k))) {
      matchedSlugs.push(topic.slug);
    }
  }
  
  return matchedSlugs;
};
